<!-- <div class="wrapper">
    <app-sidebar></app-sidebar>
    <div class="content-wrapper">
      <app-header (openChat)="getChatOpen($event)" ></app-header>
      <router-outlet></router-outlet>
    </div>
    <app-chatpanel 
    (hideChat)="getChatclose($event)"
    (openChatWindow)=getopenChatWindow($event)
    [ngClass]="{'open': showChat, 'showChat': showChatWindow }"
    >
  </app-chatpanel>
  </div>
   -->

   <router-outlet></router-outlet>